/**
 * @page 资产相关store
 * @author qingqing.yang
 * @Date 2018/7/2
 */

import { observable, action, configure, makeAutoObservable } from 'mobx';
import { calc } from '@ok/blade';

import UTIL from '_common/utils/util';

import { StepError, StepNeedErrorCode } from '../constants/StepErrorcode';
import withdrawCoinService from '../service/withdrawCoinService';

configure({
  enforceActions: 'always',
});

class withdrawCoinStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      selectCurrency: observable,
      selectNetwork: observable,
      currencyList: observable,
      currencyId: observable,
      currency: observable,
      errCode: observable,
      errMsg: observable,
      errData: observable,
      userType: observable,
      level: observable,
      filterByTargetType: observable,
      page: observable,
      withdrawList: observable,
      showStepPre: observable,
      preStepList: observable,
      dailyUsed: observable,
      dailyTotal: observable,
      lastAddress: observable,
      lastUsedReasonLabel: observable,
      lastUsedReasonValue: observable,
      addressList: observable,
      singleMin: observable,
      singleMax: observable,
      maxSizeDigit: observable,
      dailyMax: observable,
      balance: observable,
      totalBalance: observable,
      feeMin: observable,
      feeMax: observable,
      feeRate: observable,
      notWithdrawBalance: observable,
      unconfirmedBalance: observable,
      dailyFree: observable,
      limitList: observable,
      feeDefault: observable,
      targetList: observable,
      addressTargets: observable,
      needTag: observable,
      fieldStr: observable,
      tagsMessage: observable,
      needPhone: observable,
      needGoogle: observable,
      needStatus: observable,
      checkError: observable,
      checkAddressId: observable,
      targetTypeStr: observable,
      secondCheckDialog: observable,
      waitingReview: observable,
      googleVerification: observable,
      phoneVerification: observable,
      clearFlag: observable,
      confirmError: observable,
      showDeleteConfirm: observable,
      deleteId: observable,
      showCancelConfirm: observable,
      cancelCurrencyId: observable,
      cancelId: observable,
      showAddress: observable,
      addressTargetList: observable,
      accountTargetList: observable,
      addressNeedGoogle: observable,
      addressNeedPhone: observable,
      addressNeedTag: observable,
      selectAccount: observable,
      showSuccessWithdraw: observable,
      confirmAddressError: observable,
      confirmAddressErrorCode: observable,
      onConfirmAddress: observable,
      showAddDialog: observable,
      showSuccessAddress: observable,
      checkPreError: observable,
      showAddressLoading: observable,
      showSearch: observable,
      allAddressList: observable,
      confirmWithdrawLoading: observable,
      withdrawHistoryLoading: observable,
      isPhoneRegister: observable,
      userRiskLevel: observable,
      reKycStatus: observable,
      recommendedFee: observable,
      gasLimit: observable,
      innerAddressPrompt: observable,
      withdrawReasonList: observable,
      targetConfig: observable,
      updateCoin: action,
      updateNetwork: action,
      onPageChange: action,
      getWithdrawCurrencies: action,
      getWithdrawDetail: action,
      getAddressList: action,
      closeImportTip: action,
      getTargetList: action,
      getAddressTargetList: action,
      updateAddress: action,
      clearFilterType: action,
      getCheckInfo: action,
      checkInnerAddress: action,
      checkAddress: action,
      openSecondDialog: action,
      changeTarget: action,
      confirmWithdraw: action,
      getWithdrawList: action,
      deleteAddress: action,
      deleteDialog: action,
      cancelDialog: action,
      cancelWithdraw: action,
      showAddressContainer: action,
      openSuccessDialog: action,
      confirmAddress: action,
      clearData: action,
      clearLastUsedReason: action,
      changeAddressDialog: action,
      changeSuccessDialog: action,
      innerAddressDialogClose: action,
      getWithdrawReasonList: action,
      getWithdrawTargetConfig: action,
      getSelectedCurrencyId: action,
    });

    this.rootStore = rootStore;
  }

  // 币种
  selectCurrency = ''; //  下拉框选择币种
  selectNetwork = null;
  currencyList = []; //  可充值币种列表
  currencyId = -1; // 筛选币种的 currencyId
  currency = ''; // 筛选币种的 currency
  errCode = 0; // 错误码
  errMsg = ''; // 错误信息
  errData = []; // 前置条件
  userType = 0; // 用户身份信息
  level = 0; // 用户等级
  filterByTargetType = true; // 默认进入页面时 区块链地址
  page = {
    // 完成订单列表分页信息
    pageIndex: 1, // 当前页码
    pageTotal: '', // 页数
    pageSize: 20, // 每页大小
  };

  // 提现历史
  withdrawList = [];
  showStepPre = false; // 用户是否可以充值前置条件
  preStepList = []; // 前置条件列表

  dailyUsed = 0; // 已使用哪个提币额度
  dailyTotal = 0; // 24h提币额度
  lastAddress = {
    address: '',
    id: 0,
    status: 0,
    targetType: 0,
    targetUserId: 0,
    title: '',
  }; // 上次提币成功的地址

  lastUsedReasonLabel = '';
  lastUsedReasonValue = 0;
  addressList = []; // 提币地址列表
  singleMin = 0;
  singleMax = 0;
  maxSizeDigit = 0;
  dailyMax = 0;
  balance = 0;
  totalBalance = 0;
  feeMin = 0;
  feeMax = 0;
  feeRate = 0;
  notWithdrawBalance = 0;
  unconfirmedBalance = 0;
  dailyFree = 0;
  limitList = [];
  feeDefault = 0;
  targetList = [];
  addressTargets = [];
  needTag = false;
  fieldStr = '';
  tagsMessage = {
    tagsMemo: '',
    tagsMessage: [],
  };

  needPhone = true;
  needGoogle = true;
  needStatus = 0;
  checkError = '';
  checkAddressId = 0;
  targetTypeStr = '';
  secondCheckDialog = false;
  waitingReview = false;

  googleVerification = true;
  phoneVerification = true;
  clearFlag = false;
  confirmError = '';
  showDeleteConfirm = false;
  deleteId = 0;
  showCancelConfirm = false;
  cancelCurrencyId = 0;
  cancelId = 0;
  showAddress = false;
  addressTargetList = [];
  accountTargetList = [];
  addressNeedGoogle = false;
  addressNeedPhone = false;
  addressNeedTag = false;
  addAddressVerifyMethods = false;
  selectAccount = {
    address: '',
    id: 0,
    status: 0,
    targetType: 0,
    targetUserId: 0,
    title: '',
  }; // 上次提币成功的地址

  showSuccessWithdraw = false;
  confirmAddressError = '';
  confirmAddressErrorCode = '';
  onConfirmAddress = false;
  showAddDialog = false;
  showSuccessAddress = false;
  checkPreError = '';
  showAddressLoading = false;
  showSearch = true;
  allAddressList = [];
  confirmWithdrawLoading = false;
  withdrawHistoryLoading = false;
  isPhoneRegister = false;
  userRiskLevel = false;
  reKycStatus = '';
  recommendedFee = 0;
  gasLimit = 0;
  normalSecondCheckVerifyMethods = [];
  innerSecondCheckVerifyMethods = [];
  innerAddressPrompt = false;

  withdrawReasonList = [];
  targetConfig = [];
  // 更新 选择币种
  updateCoin(value) {
    this.currencyId = value.currencyId;
    this.currency = value.currency;
    this.selectCurrency = value;
    this.rootStore.loadingStore.showLoading();
    this.clearFlag = !this.clearFlag;
    this.checkError = '';
    this.selectNetwork = null;
    if (value.subCurrencies) {
      const subCurrencies = value.subCurrencies.slice();
      // 此处因为后端业务逻辑原因需要屏蔽main子链逻辑 是否永久变更未知
      const network = subCurrencies.find((c) => {
        return c.currencyId === value.currencyId;
      });
      // this.selectNetwork = network || subCurrencies[0];
      const validSubCurrencies = subCurrencies.filter((T) => {
        return T.operationalStatus !== 0;
      });
      this.selectNetwork = validSubCurrencies[0] || network;
    }

    if (this.filterByTargetType) {
      this.getAddressList(1);
      this.getWithdrawDetail('', true, -1);
    } else {
      this.getAddressList(2);
      this.getWithdrawDetail('', false);
      this.getTargetList(true);
    }
  }

  updateNetwork(value) {
    this.selectNetwork = value;
    this.getAddressList(1);
    this.getWithdrawDetail('', true, -1);
  }

  // 更新页码 并触发回调函数
  onPageChange(pageObj, page, callback, currencyId) {
    this[pageObj].pageIndex = page;
    if (callback) {
      callback.call(this, currencyId, page);
    }
  }

  //  获取可提币币种列表
  getWithdrawCurrencies(id) {
    // this.rootStore.loadingStore.showLoading();
    withdrawCoinService
      .getCurrendies({
        isWithdraw: true,
        withFavorite: true,
        filterByTargetType: this.filterByTargetType,
        needFilter: false,
      })
      .then(
        action((data) => {
          if (id !== undefined) {
            const selectCurrency = data.filter((item) => {
              return item.currencyId === id;
            })[0];
            if (selectCurrency !== undefined) {
              this.updateCoin(selectCurrency);
            }
          }
          this.rootStore.loadingStore.hideLoading();
          this.currencyList = data;
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  /**
   * 获取币种详细信息
   */
  async getWithdrawDetail(addressId, isAddress, targetType) {
    await withdrawCoinService
      .getWithdrawDetail({
        currencyId: this.getSelectedCurrencyId(),
        addressId: addressId || '',
        isAddress,
        targetType,
        needFilter: false,
      })
      .then(
        action((data) => {
          const {
            dailyTotal,
            dailyUsed,
            singleMin,
            singleMax,
            dailyMax,
            balance,
            totalBalance,
            feeMin,
            feeMax,
            feeRate,
            notWithdrawBalance,
            unconfirmedBalance,
            dailyFree,
            feeDefault,
            limitList,
            needTag,
            phoneVerification,
            googleVerification,
            level,
            waitingReview,
            specialField,
            lastReasonName,
            lastReasonType,
            maxSizeDigit,
          } = data;
          let { lastAddress } = data;
          // 在lastAddress结构中加入countryCode和stateCode
          if (lastAddress && lastAddress?.status !== -2) {
            if (lastAddress.countryCode && lastAddress.countryName) {
              lastAddress.country = {
                value: lastAddress.countryCode,
                label: lastAddress.countryName,
              };
            }
            if (lastAddress.stateCode && lastAddress.stateName) {
              lastAddress.state = {
                value: lastAddress.stateCode,
                label: lastAddress.stateName,
              };
            }
          }
          // sygna-非法地址清空
          if (lastAddress?.status === -2) {
            lastAddress = null;
          }
          this.rootStore.loadingStore.hideLoading();
          this.dailyTotal = dailyTotal;
          this.dailyUsed = dailyUsed;
          this.singleMin = Number(singleMin);
          this.singleMax = Number(singleMax);
          this.maxSizeDigit = Number(maxSizeDigit);
          this.dailyMax = Number(dailyMax);
          this.balance = Number(balance);
          this.totalBalance = Number(totalBalance);
          this.feeMin = Number(feeMin);
          this.feeMax = Number(feeMax);
          this.feeRate = Number(feeRate);
          this.lastAddress = lastAddress;
          this.lastUsedReasonLabel = lastReasonName;
          this.lastUsedReasonValue = lastReasonType;
          this.notWithdrawBalance = notWithdrawBalance;
          this.unconfirmedBalance = unconfirmedBalance;
          this.dailyFree = Number(dailyFree);
          this.feeDefault = feeDefault;
          this.limitList = limitList;
          this.needTag = needTag;
          this.phoneVerification = phoneVerification;
          this.googleVerification = googleVerification;
          this.level = level;
          this.waitingReview = waitingReview;
          if (needTag) {
            this.fieldStr = specialField.fieldStr;
            this.tagsMessage = {
              tagsMemo: specialField.tagsMemo,
              tagsMessage: specialField.tagsMessage,
            };
          }
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  /**
   * 获取该币种 地址列表
   */
  getAddressList(type) {
    if (type === 0) {
      this.rootStore.loadingStore.showLoading();
    }
    withdrawCoinService
      .getAddressList({
        currencyId: this.getSelectedCurrencyId(),
        type: type || 0,
      })
      .then(
        action((data) => {
          if (type !== 0) {
            // sygna-过滤非法地址
            this.addressList = data.addressList.filter((T) => {
              return T.status !== -2;
            });
          } else {
            this.allAddressList = data.addressList;
          }
          if (type === 0) {
            this.rootStore.loadingStore.hideLoading();
          }
        })
      )
      .catch(
        action((res) => {
          if (type === 0) {
            this.rootStore.loadingStore.hideLoading();
          }
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  /**
   *
   */
  closeImportTip() {
    this.waitingReview = false;
  }

  /**
   * 获取支持的账户类型
   */
  getTargetList(ignoreAddress) {
    const currentCurrencyId = this.getSelectedCurrencyId();
    withdrawCoinService
      .getAddressType({
        currencyId: currentCurrencyId,
        ignoreAddress,
      })
      .then(
        action((data) => {
          const { withdrawTarget } = data;
          this.targetList = withdrawTarget;
          this.getWithdrawDetail('', false, withdrawTarget[0].targetType);
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  getAddressTargetList(ignoreAddress) {
    const currentCurrencyId = this.getSelectedCurrencyId();
    this.showAddressLoading = true;
    withdrawCoinService
      .getAddressType({
        currencyId: currentCurrencyId,
        ignoreAddress,
      })
      .then(
        action((data) => {
          const {
            withdrawTarget,
            googleVerification,
            phoneVerification,
            verifyMethods,
          } = data;
          this.rootStore.loadingStore.hideLoading();
          this.addressTargets = withdrawTarget;
          this.addressTargetList = withdrawTarget.filter((item) => {
            return item.targetType === -1;
          });
          this.accountTargetList = withdrawTarget.filter((item) => {
            return item.targetType !== -1;
          });
          this.addressNeedGoogle = googleVerification;
          this.addressNeedPhone = phoneVerification;
          this.addAddressVerifyMethods = verifyMethods;
          this.addressNeedTag =
            this.addressTargetList[0] && this.addressTargetList[0].needTag;
          this.showAddressLoading = false;
        })
      )
      .catch(
        action((res) => {
          this.showAddressLoading = false;
          this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  /** *
   * 更新 选中的地址
   */
  async updateAddress(value) {
    const { canWithdraw, targetType, id, currencyId } = value;
    if (canWithdraw) {
      this.lastAddress = value;
      this.checkError = '';
      this.rootStore.loadingStore.showLoading();
      await this.getWithdrawDetail(
        id,
        this.filterByTargetType,
        targetType,
        currencyId
      );
    }
  }

  clearFilterType(show) {
    this.filterByTargetType = show;
  }

  // 前置条件 请求
  getCheckInfo() {
    this.rootStore.loadingStore.showLoading();
    withdrawCoinService
      .getCheckInfo()
      .then(
        action((res) => {
          this.showStepPre = false;
          this.userRiskLevel = res.data.userRiskLevel;
          this.checkPreError = '';
          // this.showStepPre = true;
        })
      )
      .catch(
        action((res) => {
          if (res.code === StepNeedErrorCode) {
            // 检查用户是否可以充值
            const { conditions, isPhoneRegister, reKycStatus } = res.data;
            this.reKycStatus = reKycStatus;
            this.isPhoneRegister = isPhoneRegister;
            this.showStepPre = true;
            if (reKycStatus === 0 || reKycStatus === 1) {
              conditions.push({
                code: StepError.NEED_REKYC,
                status: reKycStatus,
              });
            }
            this.preStepList = conditions;
          } else {
            this.showStepPre = false;
            this.checkPreError = res.msg;
          }
          this.rootStore.loadingStore.hideLoading();
        })
      );
  }

  // OKJ内部アドレスチェック
  checkInnerAddress(params) {
    withdrawCoinService
      .checkAddress(params)
      .then(
        action((data) => {
          const { verifyMethods } = data;
          this.innerSecondCheckVerifyMethods = verifyMethods;
        })
      )
      .catch(
        action((res) => {
          if (res.code === 4073) {
            this.innerAddressPrompt = true;
          }
        })
      );
  }

  // 检查接口是否合理
  checkAddress(params) {
    this.rootStore.loadingStore.showLoading();
    withdrawCoinService
      .checkAddress(params)
      .then(
        action((data) => {
          const {
            googleVerification,
            phoneVerification,
            status,
            addressId,
            targetTypeStr,
            recommendedFee,
            gasLimit,
            verifyMethods,
          } = data;
          this.needGoogle = googleVerification;
          this.needPhone = phoneVerification;
          this.needStatus = status;
          this.secondCheckDialog = true;
          this.checkAddressId = addressId;
          this.targetTypeStr = targetTypeStr;
          this.recommendedFee = recommendedFee;
          this.gasLimit = gasLimit;
          if (params?.targetType === 5) {
            this.innerSecondCheckVerifyMethods = verifyMethods;
          } else {
            this.normalSecondCheckVerifyMethods = verifyMethods;
          }
          this.rootStore.loadingStore.hideLoading();
          this.checkError = '';
          UTIL.handleBodyScroll({ disabled: this.secondCheckDialog });
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.hideLoading();
          this.checkError = res.msg;
        })
      );
  }

  openSecondDialog() {
    this.secondCheckDialog = !this.secondCheckDialog;
    this.confirmError = '';
  }

  //
  changeTarget(value, id) {
    if (this.filterByTargetType !== value) {
      this.selectCurrency = ''; //  下拉框选择币种
      this.selectNetwork = null;
      this.currencyList = []; //  可充值币种列表
      this.currencyId = -1; // 筛选币种的 currencyId
      this.currency = ''; // 筛选币种的 currency
      this.filterByTargetType = value;
      this.confirmError = '';
      this.getWithdrawCurrencies(id);
    }
  }

  confirmWithdraw = (params, openTravelRuleDialog) => {
    this.confirmWithdrawLoading = true;
    const confirmWithdraw =
      params.targetType !== 5
        ? withdrawCoinService.confirmWithdraw
        : withdrawCoinService.confirmWithdrawInner;
    confirmWithdraw(params)
      .then(
        action(() => {
          // 应该关闭弹框 刷新 提币列表 提币信息
          this.confirmWithdrawLoading = false;
          this.secondCheckDialog = false;
          this.clearFlag = !this.clearFlag;
          if (this.filterByTargetType) {
            this.getAddressList(1);
            this.getWithdrawDetail('', true, -1);
          } else {
            this.getAddressList(2);
            this.getWithdrawDetail('', false);
            // this.getTargetList(true);
          }
          this.getWithdrawList(this.currencyId, 1);
          this.confirmError = '';
          this.showSuccessWithdraw = true;
        })
      )
      .catch(
        action((res) => {
          this.confirmWithdrawLoading = false;
          // 提示错误信息在弹框中
          this.rootStore.loadingStore.hideLoading();
          if (res.code === 5400) {
            // Travel Rule エラー 5400
            openTravelRuleDialog(res.data);
          } else {
            this.confirmError = res.msg;
          }
          // this.secondCheckDialog = false;
        })
      );
  };

  /**
   * 获取币种 提币信息
   */
  getWithdrawList = (currencyId, currentPage) => {
    this.withdrawHistoryLoading = true;
    withdrawCoinService
      .getWithdrawList({
        currencyId: currencyId || this.currencyId,
        currentPage,
        pageLength: this.page.pageSize,
      })
      .then(
        action((data) => {
          const { withdrawHistory, total } = data;
          withdrawHistory.forEach((item) => {
            const list = item;
            list.showAmount = calc.showFloorTruncation(list.amount, 8);
            list.showWithdrawFee = calc.showFloorTruncation(list.fee, 4);
            list.showTime = UTIL.formatTimestamp(
              list.createDate,
              'yyyy-MM-dd hh:mm:ss'
            );
          });
          this.page.pageTotal = Math.ceil(total / this.page.pageSize);
          this.withdrawList = withdrawHistory;
          this.page.pageIndex = currentPage;
          this.withdrawHistoryLoading = false;
        })
      )
      .catch(
        action((res) => {
          // 提示错误信息在弹框中
          this.withdrawHistoryLoading = false;
          this.listError = res.msg;
        })
      );
  };

  /**
   * 删除提现地址
   */
  deleteAddress = (id) => {
    withdrawCoinService
      .deleteAddress({
        addressId: id || this.deleteId,
      })
      .then(
        action(() => {
          if (this.showAddress) {
            this.getAddressList(0);
          } else if (this.filterByTargetType) {
            this.getAddressList(1);
          } else {
            this.getAddressList(2);
          }
          if (this.filterByTargetType) {
            this.getWithdrawDetail('', true, -1);
          } else {
            this.getWithdrawDetail('', false);
          }
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  };

  /**
   * 删除地址 确认弹框
   */
  deleteDialog = (id) => {
    if (id) {
      this.deleteId = id;
    }
    this.showDeleteConfirm = !this.showDeleteConfirm;
  };

  /**
   * 取消 提现 弹框
   */
  cancelDialog = (cancelCurrencyId, id) => {
    if (cancelCurrencyId !== undefined) {
      this.cancelCurrencyId = cancelCurrencyId;
      this.cancelId = id;
    }
    this.showCancelConfirm = !this.showCancelConfirm;
  };

  /**
   * 确认取消提现
   */
  cancelWithdraw = () => {
    withdrawCoinService
      .cancelWithdraw({
        currencyId: this.cancelCurrencyId,
        id: this.cancelId,
      })
      .then(
        action(() => {
          this.cancelDialog();
          this.getWithdrawList(this.currencyId, 1);
        })
      )
      .catch(
        action((res) => {
          this.cancelDialog();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  };

  /**
   * 显示 地址列表
   */
  showAddressContainer = (show) => {
    this.showAddress = show;
    if (!show) {
      this.addressTargets = [];
    }
  };

  /**
   * 成功提币
   */
  openSuccessDialog = () => {
    this.showSuccessWithdraw = !this.showSuccessWithdraw;
  };

  /**
   * 确认添加地址
   */
  confirmAddress = (params, openTravelRuleDialog) => {
    this.onConfirmAddress = true;
    withdrawCoinService
      .confirmAddress(params)
      .then(
        action(() => {
          this.getAddressList(0);
          this.confirmAddressError = '';
          this.confirmAddressErrorCode = '';
          this.showAddDialog = !this.showAddDialog;
          this.showSuccessAddress = !this.showSuccessAddress;
          this.onConfirmAddress = false;
        })
      )
      .catch(
        action((res) => {
          if (res.code === 5400) {
            // Travel Rule エラー 5400
            openTravelRuleDialog(res.data);
          } else {
            this.confirmAddressErrorCode = res.code;
            this.confirmAddressError = res.msg;
          }
          this.onConfirmAddress = false;
        })
      );
  };

  /**
   * 页面注销 清除币种等信息
   */
  clearData = () => {
    this.showAddress = false;
    this.selectCurrency = null;
    this.selectNetwork = null;
    this.withdrawList = [];
    this.secondCheckDialog = false;
    this.showStepPre = false;
    this.checkError = '';
    this.addressTargets = [];
    this.confirmError = '';
    this.currencyId = -1;
    this.balance = 0;
    this.totalBalance = 0;
    this.feeDefault = 0;
    this.filterByTargetType = true;
    this.clearFlag = false;
    this.userRiskLevel = false;
  };

  /* 前回使用した取引目的をクリアする */
  clearLastUsedReason = () => {
    this.lastUsedReasonLabel = '';
    this.lastUsedReasonValue = 0;
  };

  /**
   * 展示添加地址弹框
   */
  changeAddressDialog = () => {
    this.confirmAddressError = '';
    this.confirmAddressErrorCode = '';
    this.showAddDialog = !this.showAddDialog;
  };

  changeSuccessDialog = () => {
    this.showSuccessAddress = !this.showSuccessAddress;
  };

  innerAddressDialogClose = () => {
    this.confirmAddressError = '';
    this.confirmAddressErrorCode = '';
    this.innerAddressPrompt = false;
  };

  async getWithdrawReasonList(params) {
    const withdrawReasonList = [];
    await withdrawCoinService
      .getWithdrawReasonList({
        onChainReason: this.filterByTargetType,
        ...params,
      })
      .then(
        action((list) => {
          list &&
            list.forEach((item) => {
              withdrawReasonList.push({
                value: item.value,
                label: item.label,
                message: item.message,
              });
            });
          this.withdrawReasonList = withdrawReasonList;
        })
      );
  }

  async getWithdrawTargetConfig(notMergeSubType) {
    await withdrawCoinService.getWithdrawTargetConfig().then(
      action((data) => {
        // 在此处处理本人以外分成个人法人的问题，防止多次改动引发天坑
        // mock
        // data.targetUserSubType = [
        //   { subTypeName: '個人', code: 1 },
        //   { subTypeName: '法人', code: 2 },
        // ];
        // data.legalEntity = [
        //   { legalEntityName: '株式会社', code: 1 },
        //   { legalEntityName: '合同会社', code: 2 },
        // ];
        // data.legalEntityPos = [
        //   { position: '法人格前', code: 1 },
        //   { position: '法人格後', code: 2 },
        // ];
        if (
          notMergeSubType !== true &&
          data.targetUserType instanceof Array &&
          data.targetUserType.find((T) => {
            return T.typeName === '本人以外';
          }) !== undefined &&
          data.targetUserSubType instanceof Array
        ) {
          // 把targetUserType的本人以外分成两个选项，id直接合并targetUserSubType字段
          const myself = data.targetUserType.find((T) => {
            return T.typeName === '本人';
          });
          const other = data.targetUserType.find((T) => {
            return T.typeName === '本人以外';
          });
          // eslint-disable-next-line no-param-reassign
          data.targetUserType = [
            myself,
            ...data.targetUserSubType.map((T) => {
              return {
                typeName: `${other.typeName}（${T.subTypeName}）`,
                type: Number(`${other.type}${T.code}`),
                orginalType: other,
                orginalSubType: T,
              };
            }),
          ];
        }
        this.targetConfig = data;
      })
    );
  }

  getSelectedCurrencyId() {
    return this.selectNetwork ? this.selectNetwork.currencyId : this.currencyId;
  }

  checkWithdraw(params) {
    return withdrawCoinService.checkWithdraw(params);
  }
}

export default withdrawCoinStore;
